@for (digit of digits(); track $index) {
<input
  #box
  class="auth-code__box"
  type="text"
  inputmode="numeric"
  pattern="[0-9]*"
  [autocomplete]="$first ? 'one-time-code' : 'off'"
  [attr.aria-label]="label() + ' — dígito ' + ($index + 1) + ' de ' + digits().length"
  [value]="digit"
  [disabled]="isDisabled()"
  (input)="handleInput($index, $event)"
  (keydown)="handleKeydown($index, $event)"
  (paste)="handlePaste($index, $event)"
  (focus)="selectBox($event)"
  (blur)="handleBlur()"
/>
}
